<template>
<div>
  <div class="menu">
      <div class="content1">
        <!-- <div class="logo">
          <router-link to="/">千种药用植物基因组数据库</router-link>
        </div> -->
        <div class="btn">
          <!-- <el-menu class="el-menu-demo" mode="horizontal">
            <el-menu-item index="1" class="black"><router-link to="/">Home</router-link></el-menu-item>
            <span></span>
            <el-menu-item index="3"><router-link to="/blastcenter">Blast</router-link></el-menu-item>
             <el-menu-item index="4">|</el-menu-item>
            <el-menu-item index="5"><router-link to="/primer">Primer design</router-link> </el-menu-item>
            <el-menu-item index="3"><router-link to="/download">Download</router-link></el-menu-item> 
          </el-menu> -->
          <ul>
            <li class="black"><router-link to="/">Home</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/blastcenter">Blast</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/primer">Primer design</router-link></li>
          </ul>
        </div>
      </div>
    </div>
  <div class="contenter">
    <div class="title">
      <span class="el-icon-document"></span>
      <span>权重共表达分析（WGCNA）</span>
    </div>
    <div class="des">
       权重共表达分析（WGCNA, Weighted correlation network analysis）是利用分子间的表达相关系数来衡量它们的共表达关系，同一模块中的分子表达模式相似，而和其他模块分子表达模式差别较大。表达模式相似的分子可能参与同一生物学过程或通路。因而，可将复杂的组学数据简化为若干个功能模块，这些模块和表型信息关联，可发现有生物学意义的模块。通过WGCNA的分析，采用降维的方式，可以把几千上万的基因表达谱，转化成共表达模块，再对这个模块的基因做细致的分析，找出与目标代谢物相关的基因。
    </div>
    <div class="img">
      <img src="../../../assets/u123.png" /><br /><br />
      <span>权重共表达分析（WGCNA）示例 </span><br />
      <span>
       Mateus ID, Masclaux FG, Aletti C, et al. Dual RNA-seq reveals large-scale non-conserved<br/> genotype × genotype-specific genetic reprograming and molecular crosstalk in the<br/> mycorrhizal symbiosis. ISME J. 2019 May;13(5):1226-1238.
      </span
      >
    </div>
  </div></div>
</template>
<script>
export default {};
</script>
<style scoped>
.menu {
  width: 100%;
  height: 60px;
  flex: 0;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  box-shadow: 1px 1px 2px #ccc;
}
.menu .content1 {
  width: 1200px;
  height: 50px;
  margin: 0 auto;
  /* border: 1px solid red; */
}
.menu .black {
  color: #000;
}
.menu .content1 .logo {
  float: left;
  width: 250px;
  height: 50px;
  margin: 5px 0;
  /* border: 1px solid #ccc; */
  line-height: 50px;

  text-align: center;
}
.menu .content1 .logo a {
  text-decoration: none;
  font-size: 20px;
  color: seagreen;
  font-weight: bold;
}
.menu .content1 .btn {
  /* float: right; */
  width: auto;
}
.menu .content1 .btn ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.menu .content1 .btn ul li {
  float: left;
  padding: 0 20px;
  line-height: 50px;
}
.menu .content1 .btn ul li.ww {
  color: #ccc;
}
.menu .content1 .btn ul li a {
  text-decoration: none;
  color: #333;
  font-size: 14px;
}
.menu .content1 .btn ul li:nth-child(1) a {
  color: #000;
  font-weight: 700;
}
.menu .content1 .btn .el-menu.el-menu--horizontal {
  border: none;
}
.contenter {
  width: 1140px;
  margin: 0 auto;
  /* height: 500px; */
  box-shadow: 0 0 10px #bbb;
  padding: 0 30px;
  background: #fff;
}
.contenter .title {
  height: 70px;
  width: 100%;
  /* border: 1px solid red; */
  line-height: 70px;
  font-size: 16px;
  font-weight: bold;
}
.contenter .title .el-icon-document {
  margin-right: 10px;
  font-size: 20px;
  /* line-height: 30px; */
  color: seagreen;
  font-weight: bold;
}
.contenter .des {
  background: #eef6f0;
  color: #555;
  line-height: 25px;
  padding: 15px 20px;
  font-size: 14px;
  text-indent: 30px;
}
.contenter .img {
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  line-height: 25px;
  overflow: auto;
  padding-bottom: 30px;
}
</style>